export interface MobileNavItem {
  href: string;
  label: string;
  aliases?: string[];
}

export interface MobileNavSection<TItem extends MobileNavItem = MobileNavItem> {
  title: string;
  items: TItem[];
}

export function buildMobileNavSections<TItem extends MobileNavItem>(
  _mainItems: TItem[],
  _adminItems: TItem[],
): MobileNavSection<TItem>[] {
  return [
    { title: 'Work', items: _mainItems },
    { title: 'Controls', items: _adminItems },
  ];
}

export function isMobileNavRouteActive(href: string, location: string, aliases: string[] = []) {
  return [href, ...aliases].some((path) => location === path || location.startsWith(`${path}/`));
}

export function currentMobileNavTitle(location: string, items: MobileNavItem[]) {
  const match = items.find((item) => isMobileNavRouteActive(item.href, location, item.aliases));
  return match?.label || 'Outreach';
}
